import React from 'react'
import SEOHead from '../components/SEOHead'
import './AboutPage.css'

const AboutPage: React.FC = () => {
  return (
    <div className="about-page">
      <SEOHead
        title="About Fast Boat Trailers - Edgewater MD Marine Transport Experts"
        description="Fast Boat Trailers in Edgewater, MD provides premium boat trailers, custom builds, and marine transport solutions. Family-owned business serving Maryland, Virginia, and surrounding areas."
        keywords="about fast boat trailers, Edgewater MD boat trailers, marine transport experts, custom trailer builds, boat trailer dealer Maryland, 410-570-9150"
        ogTitle="About Fast Boat Trailers - Edgewater MD Marine Transport Experts"
        ogDescription="Fast Boat Trailers in Edgewater, MD provides premium boat trailers, custom builds, and marine transport solutions. Family-owned business serving Maryland & Virginia."
        ogImage="/images/logos/fbt-logo-3-noborder.jpeg"
        canonical="https://fastboattrailers.com/about"
      />
      <div className="container">
        <div className="about-hero">
          <h1>About Fast Boat Trailers</h1>
        </div>
        
        <div className="about-content">
          <p>
            Fast Boat Trailers is your premier destination for high-quality boat trailers in Maryland.
            Located in Edgewater, we specialize in providing reliable, durable trailers that get your
            boat safely to and from the water.
          </p>
          <p>
            Our trailers are proudly made in the USA, ensuring the highest standards of quality and
            craftsmanship. We offer a complete range of aluminum and galvanized trailers to meet
            every boating need, from small personal watercraft to large fishing boats.
          </p>
          
          <h2>Our Services</h2>
          <ul>
            <li>New trailer sales</li>
            <li>Custom trailer builds</li>
            <li>Trailer maintenance and repair</li>
            <li>Parts and accessories</li>
            <li>Expert consultation and advice</li>
          </ul>
          
          <h2>Our Address</h2>
          <div className="location-section">
            <p>
              <strong>Address:</strong> 313 Edgewater Dr, Edgewater, MD 21037<br/>
              <strong>Phone:</strong> <a href="tel:410-570-9150">410-570-9150</a><br/>
              <strong>Serving:</strong> Maryland, Virginia, and surrounding areas
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutPage